module.exports = __webpack_public_path__ + "static/media/logo_old.e65accb1.png";